import React from 'react'

const BottomFooter = () => {
    return (
        <div className="bottom-footer bg-color-one py-8">
            <div className="container container-lg">
                <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
                    <p className="bottom-footer__text ">
                        Buildton.in © 2025. All Rights Reserved{" "}
                    </p>
<p className="text-heading">
  <a href="/register-b2b" className="text-decoration-none text-heading">
    <i className="fas fa-user-tie me-2" />
    Register as B2B
  </a>
</p>

<p className="text-heading">
  <a href="/advertise" className="text-decoration-none text-heading">
    <i className="fas fa-bullhorn me-2" />
    Advertise
  </a>
</p>

<p className="text-heading">
  <a href="/help-center" className="text-decoration-none text-heading">
    <i className="fas fa-question-circle me-2" />
    Help Center
  </a>
</p>

                    <div className="flex-align gap-8 flex-wrap">
                        <span className="text-heading text-sm">We Are Acepting</span>
                        <img src="../assets/images/thumbs/payment-method.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BottomFooter